<!--
 Created by Xuz on 2019/02/19.
 xuz[at]live[dot]cn
 用户编辑
-->
<template>
  <a-modal title="编辑用户"
           :width="960"
           :visible="visible"
           :maskClosable="false"
           :confirmLoading="modalLoading.editUser"
           destroyOnClose
           @cancel="onCancel"
           class="user-form">
    <template slot="footer">
      <a-button type="danger" @click="onDeleteUser">删除用户</a-button>
      <a-button @click="onCancel">取消</a-button>
      <a-button type="primary" @click="onEditUserSubmit" :loading="modalLoading.editUser">确定</a-button>
    </template>
    <a-form :form="editUserForm">
      <a-tabs size="small">
        <a-tab-pane tab="帐号信息" key="1" forceRender>
          <div style="position: absolute;right: 22px;text-align: center;z-index:9;">
            <div style="margin-bottom: 8px">
              <img style="width: 72px;height: 90px;object-fit: cover"
                   :src="$_c + 'api/1/user/avatar?id=' + modalData.editUser.id + '&_=' + ts">
            </div>
            <a @click="onEditAvatar" style="cursor:pointer;">
              <a-icon type="edit"/>
              修改头像</a>
          </div>
          <a-row>
            <a-col :span="12">
              <a-form-item label='所属机构' v-bind="formItemLayout">
                {{ modalData.editUser.org.name }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label='所属部门' v-bind="formItemLayout">
                {{ modalData.editUser.dept.name }}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label='所属岗位' v-bind="formItemLayout">
                {{ modalData.editUser.pos.name }}
                <a-button icon="edit" size="small" type="danger" @click="onMoveUserPos">调动</a-button>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label='顺序号' v-bind="formItemLayout">
                <a-input-number v-decorator="[
                                    'seq',
                                    {initialValue:modalData.editUser.seq, rules: [{ required: true, type: 'number', message: '请填写数字类型顺序号' }]}]"
                                placeholder='顺序号'/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label='帐号名' v-bind="formItemLayout">
                <a-input v-decorator="[
                                    'account',
                                    {initialValue:modalData.editUser.account, rules: [{ required: true, message: '请填写帐号' }]}]"
                         placeholder='登录使用'/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label='姓名' v-bind="formItemLayout">
                <a-input v-decorator="[
                                    'name',
                                    {initialValue:modalData.editUser.name, rules: [{ required: true, message: '请填写姓名' }]}]"
                         placeholder='姓名'/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label='密码' v-bind="formItemLayout">
                <a-input v-decorator="[
                                    'password',
                                    {initialValue:modalData.editUser.password, rules: [{ required: false, message: '请填写密码' }, { validator: onCheckPasswordStrength }]}]"
                         type='password' placeholder='留空不修改密码'>
                  <template slot="suffix">
                    <a-tag color="red" v-if="passwordStrengthId === 0" class="pwd-tip">弱</a-tag>
                    <a-tag color="orange" v-else-if="passwordStrengthId === 1" class="pwd-tip">一般</a-tag>
                    <a-tag color="blue" v-else-if="passwordStrengthId === 2" class="pwd-tip">强</a-tag>
                    <a-tag color="green" v-else-if="passwordStrengthId === 3" class="pwd-tip">很强</a-tag>
                    <span v-else></span>
                  </template>
                </a-input>
                <a-tooltip>
                  <template slot="title">
                    <p><a-icon style="margin-right: 4px;" theme="twoTone" two-tone-color="#ff9800" type="exclamation-circle"/>长度为8~20个字符</p>
                    <p><a-icon style="margin-right: 4px;" theme="twoTone" two-tone-color="#ff9800" type="exclamation-circle"/>不能使用空格、中文</p>
                    <p><a-icon style="margin-right: 4px;" theme="twoTone" two-tone-color="#ff9800" type="exclamation-circle"/>至少含数字、小写/大写字母、特殊字符中的三种及以上</p>
                  </template>
                  <a-icon class="zdy_icon_pass_tips" type="question-circle"/>
                </a-tooltip>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label='确认密码' v-bind="formItemLayout">
                <a-input v-decorator="[
                                    'password2',
                                    {initialValue:modalData.editUser.password2, rules: [{ required: false, message: '请再次填写密码' }]}]"
                         type='password' placeholder='留空不修改密码'/>
                <a-tooltip>
                  <template slot="title">
                    <p><a-icon style="margin-right: 4px;" theme="twoTone" two-tone-color="#ff9800" type="exclamation-circle"/>长度为8~20个字符</p>
                    <p><a-icon style="margin-right: 4px;" theme="twoTone" two-tone-color="#ff9800" type="exclamation-circle"/>不能使用空格、中文</p>
                    <p><a-icon style="margin-right: 4px;" theme="twoTone" two-tone-color="#ff9800" type="exclamation-circle"/>至少含数字、小写/大写字母、特殊字符中的三种及以上</p>
                  </template>
                  <a-icon class="zdy_icon_pass_tips" type="question-circle"/>
                </a-tooltip>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label='邮箱' v-bind="formItemLayout">
                <a-input v-decorator="[
                                    'email',
                                    {initialValue:modalData.editUser.email, rules: [{ required: false, message: '请填写邮箱' },
                                    {type: 'email', message: 'Email 格式不正确' }]}]" placeholder='邮箱'/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label='手机' v-bind="formItemLayout">
                <a-input v-decorator="[
                                    'mobile',
                                    {initialValue:modalData.editUser.mobile, rules: [{ required: false, message: '请填写手机号码' }]}]"
                         placeholder='手机号码'/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label='平台sid' v-bind="formItemLayout">
                <a-input v-decorator="[
                                    'sid',
                                    {initialValue:userSid.tacsUserId, rules: [{ required: false, message: 'sid' }]}]"
                         placeholder='sid'/>
              </a-form-item>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane tab="基本资料" key="2" forceRender>
          <a-row>
            <a-col :span="12">
              <a-form-item label='性别' v-bind="formItemLayout">
                <a-radio-group v-decorator="[
                                    'sex', {initialValue:modalData.editUser.profile.sex}]">
                  <a-radio value="1">男</a-radio>
                  <a-radio value="0">女</a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label='出生日期' v-bind="formItemLayout">
                <a-date-picker v-decorator="[
                                        'birthday', {initialValue:modalData.editUser.profile.birthday}]"
                               placeholder='出生日期'/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label='婚姻状况' v-bind="formItemLayout">
                <a-select v-decorator="[
                                    'marital', {initialValue:modalData.editUser.profile.marital}]" allowClear>
                  <a-select-option value="single">未婚</a-select-option>
                  <a-select-option value="married">已婚</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label='工作电话' v-bind="formItemLayout">
                <a-input v-decorator="[
                                    'workPhone', {initialValue:modalData.editUser.profile.workPhone}]"
                         placeholder='工作电话'/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label='入职日期' v-bind="formItemLayout">
                <a-date-picker v-decorator="[
                                        'hireDate', {initialValue:modalData.editUser.profile.hireDate}]"
                               placeholder='入职日期'/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item
                  label='参加工作时间'
                  v-bind="formItemLayout">
                <a-date-picker v-decorator="['firstWorkDate', {initialValue:modalData.editUser.profile.firstWorkDate}]"
                               placeholder='参加工作时间'/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item
                  label='企业微信号码'
                  v-bind="formItemLayout">
                <a-input v-decorator="['weixinId', {initialValue:modalData.editUser.profile.weixinId}]"
                         placeholder='企业微信号码'/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                  label='联系地址'
                  :labelCol="{ span: 3 }"
                  :wrapperCol="{ span: 18 }">
                <a-input v-decorator="[
                                        'address',
                                        {initialValue:modalData.editUser.profile.address}]" placeholder='联系地址'/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                  label='备注'
                  :labelCol="{ span: 3 }"
                  :wrapperCol="{ span: 18 }">
                <a-textarea v-decorator="[
                                        'description',
                                        {initialValue:modalData.editUser.profile.description}]" :rows="2"/>
              </a-form-item>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane tab="任职情况" key="3" forceRender>
          <a-row>
            <a-col>
              <a-table ref="posTable"
                       :columns="posColumns"
                       :rowKey="record => (record.org_id + record.dept_id + record.pos_id)"
                       :dataSource="posItems"
                       :pagination="false"
                       size="middle">
                <template slot="duty" slot-scope="record">
                  <dict-cascader dictKey="HR.POS" style="width:120px" :value="record.duty"
                                 @change="(value, selectedOptions) => onEditPosDuty(record.pos_id, value, selectedOptions)"/>
                </template>
                <template slot="seq" slot-scope="record">
                  <a-input-number style="width:72px" placeholder="排序" :min="0" :value="record.seq"
                                  @change="value => onEditPosSeq(record.pos_id, value,'seq')"/>
                </template>
                <span slot="action" slot-scope="text, record">
                                    <a v-if="record.types === '1'" @click="onMoveUserPos">调动</a>
                                    <a-popconfirm v-else title="是否确认撤职?" @confirm="onDeletePos(record)">
                                        <a href="#">撤职</a>
                                    </a-popconfirm>
                                </span>
              </a-table>
            </a-col>
          </a-row>
          <a-row style="margin-top:10px">
            <a-col style="float:right">
              <a-button @click="onSavePosProp" class="half-button">保存职务排序</a-button>&nbsp;<a-button
                @click="onAddUserPos">新增职位关联
            </a-button>
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>
    </a-form>
    <UserPosAdd ref="userPosAdd" :visible="modalVisible.userPosAdd" @success="onAddUserPosSuccess"
                @cancel="onAddUserPosCancel"/>
    <UserPosMove ref="userPosMove" :visible="modalVisible.userPosMove" @success="onMoveUserPosSuccess"
                 @cancel="onMoveUserPosCancel"/>
    <UserAvatar ref="userAvatar" @success="onUploadAvatar"/>
  </a-modal>
</template>

<script>
import qs from 'qs'
import moment from 'moment'
import UserPosAdd from './UserPosAdd'
import UserPosMove from './UserPosMove'
import UserAvatar from './UserAvatar'
import DictCascader from '@/components/dict/DictCascader'
import passwordStrength from 'check-password-strength'

const posColumns = [
  {
    title: '机构',
    dataIndex: 'org_name'
  },
  {
    title: '部门',
    dataIndex: 'dept_name'
  },
  {
    title: '岗位',
    dataIndex: 'pos_name'
  },
  {
    title: '类型',
    dataIndex: 'type_name'
  },
  {
    title: '职务',
    scopedSlots: { customRender: 'duty' },
    width: '140px'
  },
  {
    title: '排序',
    scopedSlots: { customRender: 'seq' },
    width: '100px'
  },
  {
    title: '操作',
    width: '100px',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  name: 'UserEdit',
  components: {
    UserAvatar,
    UserPosAdd,
    UserPosMove,
    DictCascader
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      posColumns: posColumns,
      formItemLayout: {
        labelCol: {
          md: { span: 6 }
        },
        wrapperCol: {
          md: { span: 12 }
        }
      },
      editUserForm: this.$form.createForm(this),
      modalLoading: {
        editUser: false
      },
      modalData: {
        editUser: {
          org: {},
          dept: {},
          pos: {},
          profile: {}
        }
      },
      modalVisible: {
        userPosAdd: false,
        userPosMove: false
      },
      posItems: [],
      userSid: [],
      passwordStrengthId: null,
      ts: new Date().getTime()
    }
  },
  methods: {
    onInit (userId) {
      this.modalLoading.editUser = true
      this.modalData.editUser.id = userId
      const that = this
      Promise.all([
        this.$http.get('/api/1/org/get_user.json?id=' + userId),
        that.$http.get('/api/1/org/get_user_poss.json?pageSize=99&userId=' + that.modalData.editUser.id)
      ]).then(function ([respUser, respPos]) {
        let result = respUser.result
        if (result.profile.birthday) {
          result.profile.birthday = moment(result.profile.birthday)
        }
        if (result.profile.hireDate) {
          result.profile.hireDate = moment(result.profile.hireDate)
        }
        if (result.profile.firstWorkDate) {
          result.profile.firstWorkDate = moment(result.profile.firstWorkDate)
        }
        that.modalData.editUser = result

        // 解决IE兼容性问题
        that.editUserForm.setFieldsValue({ seq: result.seq })
        that.posItems = respPos.result

        that.modalLoading.editUser = false
        that.onGetSid()
      })
    },
    onGetPosList () {
      const that = this
      that.$http.get('/api/1/org/get_user_poss.json?pageSize=99&userId=' + that.modalData.editUser.id).then(function (resp) {
        that.posItems = resp.result
      })
    },
    onGetSid () {
      const that = this
      that.$http.get('/api/v1/portal/get_user_sid?userId=' + that.modalData.editUser.id).then(function (resp) {
        that.userSid = resp.result
      })
    },
    onDeleteUser (event) {
      const that = this
      let title = '是否确定删除账号？'
      let logicalDelete = 1
      if (event.ctrlKey && event.altKey) {
        logicalDelete = 0
        title += '删除后将无法恢复账号'
      }
      this.$confirm({
        title: title,
        onOk () {
          that.onDeleteUserSubmit(logicalDelete)
        }
      })
    },
    onDeleteUserSubmit (deleteType) {
      const that = this
      let params = { id: this.modalData.editUser.id }
      // 默认是逻辑删除
      let url = '/api/1/org/remove_user.json'
      if (deleteType === 0) {
        // 物理删除，无法恢复哟
        url = '/api/1/org/delete_user.json'
      }
      this.$http.post(url, qs.stringify(params)).then(function (response) {
        if (response.code !== 200) {
          that.$message.error(response.msg)
          return
        }
        that.$message.success('删除成功')
        that.$emit('success')
      })
    },
    onEditUserSubmit () {
      let that = this
      this.editUserForm.validateFields((err, values) => {
        if (err) {
          return
        }
        let params = this.editUserForm.getFieldsValue()

        if (params.password || params.password2) {
          if (params.password !== params.password2) {
            that.$message.warning('两次密码输入不一致')
            return
          }
        }

        params.orgId = this.modalData.editUser.orgId
        params.deptId = this.modalData.editUser.deptId
        params.posId = this.modalData.editUser.posId
        params.id = this.modalData.editUser.id
        if (params.birthday) {
          params.birthday = params.birthday.format('YYYY-MM-DD')
        }
        if (params.hireDate) {
          params.hireDate = params.hireDate.format('YYYY-MM-DD')
        }
        if (params.firstWorkDate) {
          params.firstWorkDate = params.firstWorkDate.format('YYYY-MM-DD')
        }
        params.saveProfile = '1'
        this.modalLoading.editUser = true


        console.log(params)
        console.log(params.sid)

        //这里再更新下平台得sid
        this.$http.post('/api/v1/portal/update_user_sid.json?userId=' + this.modalData.editUser.id + '&sid=' + params.sid, qs.stringify()).then(function (response) {
          if (response.code !== 200) {
            that.$message.error(response.msg)
            return
          }
        })
        this.$http.post('/api/1/org/edit_user.json', qs.stringify(params)).then(function (response) {
          that.modalLoading.editUser = false
          if (response.code !== 200) {
            that.$message.error(response.msg)
            return
          }

          that.$message.success('操作成功')
          that.editUserForm.resetFields()
          that.$emit('success')
        })
      })
    },
    onAddUserPos () {
      this.modalVisible.userPosAdd = true
      this.$refs.userPosAdd.preUserPosAdd(this.modalData.editUser.id)
    },
    onEditPosDuty (id, value, selectedOptions) {
      const newData = [...this.posItems]
      const target = newData.filter(item => id === item.pos_id)[0]
      if (target) {
        const tmp = value.split(',')
        target['duty'] = tmp[tmp.length - 1]
        this.posItems = newData
      }
    },
    onEditPosSeq (id, value, column) {
      const newData = [...this.posItems]
      const target = newData.filter(item => id === item.pos_id)[0]
      if (target) {
        target[column] = value
        this.posItems = newData
      }
    },
    onSavePosProp () {
      const that = this
      let requests = []
      that.posItems.forEach(function (item) {
        if (item.types === '1') {
          that.modalData.editUser.seq = item.seq
        }
        const params = {
          posId: item.pos_id,
          duty: item.duty,
          seq: item.seq,
          type: item.types,
          userId: that.modalData.editUser.id
        }
        requests.push(that.$http.post('/api/1/org/edit_user_pos.json', qs.stringify(params)))
      })
      Promise.all(requests).then(function () {
        that.$message.success('操作成功')
      })
    },
    onAddUserPosCancel () {
      this.modalVisible.userPosAdd = false
    },
    onAddUserPosSuccess () {
      this.modalVisible.userPosAdd = false
      this.onGetPosList()
    },
    onDeletePos (record) {
      const that = this
      that.$http.post('/api/1/org/delete_user_pos.json', qs.stringify({
        userId: that.modalData.editUser.id,
        posId: record.pos_id
      })).then(function (response) {
        that.modalLoading.editUser = false
        if (response.code !== 200) {
          that.$message.error(response.msg)
          return
        }
        that.onGetPosList()
      })
    },
    onMoveUserPos () {
      this.modalVisible.userPosMove = true
      this.$refs.userPosMove.preUserPosMove(this.modalData.editUser.id)
    },
    onMoveUserPosCancel () {
      this.modalVisible.userPosMove = false
    },
    onMoveUserPosSuccess () {
      this.modalVisible.userPosMove = false
      this.onInit(this.modalData.editUser.id)
    },
    onCheckPasswordStrength (rule, value, cb) {
      this.passwordStrengthId = passwordStrength.passwordStrength(value).id
      cb()
    },
    onEditAvatar () {
      console.log('onEditAvatar')
      this.$refs.userAvatar.edit(this.modalData.editUser.id)
    },
    onUploadAvatar () {
      this.ts = new Date().getTime()
    },
    onCancel () {
      console.log('onCancel')
      this.passwordStrengthId = null
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="less">
.user-form .ant-modal-body {
  padding: 4px 14px 14px 14px;
}

.user-form .half-button {
  border-color: orange;
}

.pwd-tip {
  margin-right: 0;
}
.zdy_icon_pass_tips {
  color: #ff4d4f;
  position: absolute;
  margin-top: 13px;
  margin-left: 6px;
  cursor: pointer;
}
</style>
